/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/require-default-props */
/* eslint-disable react/function-component-definition */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-no-useless-fragment */

import CheckIconAlt from '@src/svgs/CheckIconAlt';
import React from 'react';
import styled from 'styled-components';

import SpeakerSelector from '../content-components/SpeakerSelector';

import type { Speaker } from '../content-components/SpeakerSelector';

interface SpeakerFilterComponentProps {
  speakers: Speaker[];
  selectedSpeakers: Speaker[];
  setSelectedSpeakers: (speakers: Speaker[]) => void;
  useSpeakerFilter: boolean;
  setUseSpeakerFilter: (
    useFilter: boolean | ((prev: boolean) => boolean),
  ) => void;
  isLoadingSpeakers: boolean;
  title?: string;
  infoText?: string;
  align?: 'center' | 'left';
}

/**
 * Reusable component for speaker filtering
 * Can be used in any UI that needs to filter content by speaker
 */
const SpeakerFilterComponent: React.FC<SpeakerFilterComponentProps> = ({
  align = 'left',
  speakers,
  selectedSpeakers,
  setSelectedSpeakers,
  useSpeakerFilter,
  setUseSpeakerFilter,
  isLoadingSpeakers,
  title = 'Filter Clips by Speaker',
  infoText = '',
}) => (
  <SpeakerFilterSection data-testid="clip-producer-speaker-filter">
    <SpeakerFilterHeader>
      <CheckBoxContainer
        align={align}
        onClick={() => setUseSpeakerFilter(prev => !prev)}
        disabled={isLoadingSpeakers || speakers.length === 0}
      >
        <CheckBox isChecked={useSpeakerFilter} role="button">
          {useSpeakerFilter && <CheckIconAlt />}
        </CheckBox>
        <div className="checkbox-text">{title}</div>
      </CheckBoxContainer>

      {useSpeakerFilter && speakers.length > 0 && !isLoadingSpeakers && (
        <SpeakerActions>
          <ActionButton onClick={() => setSelectedSpeakers(speakers)}>
            Select All
          </ActionButton>
          <ActionButton onClick={() => setSelectedSpeakers([])}>
            Deselect All
          </ActionButton>
        </SpeakerActions>
      )}
    </SpeakerFilterHeader>

    {useSpeakerFilter && (
      <>
        {isLoadingSpeakers ? (
          <LoadingText>Loading speakers...</LoadingText>
        ) : speakers.length === 0 ? (
          <NoSpeakersText>No speakers found in this video</NoSpeakersText>
        ) : (
          <HelperText align={align}>Select all that apply</HelperText>
        )}
        {!isLoadingSpeakers && speakers.length > 0 && (
          <SpeakerSelectorContainer>
            <SpeakerSelector
              speakers={speakers}
              selectedSpeakers={selectedSpeakers}
              onChange={setSelectedSpeakers}
            />
            {infoText && <SpeakerInfo>{infoText}</SpeakerInfo>}
          </SpeakerSelectorContainer>
        )}
      </>
    )}
  </SpeakerFilterSection>
);

export default SpeakerFilterComponent;

// Styled components
const SpeakerFilterSection = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const SpeakerFilterHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const SpeakerActions = styled.div`
  display: flex;
  gap: 8px;
  flex-shrink: 0;
`;

const ActionButton = styled.button`
  background-color: var(--surface);
  color: var(--text-secondary);
  border: 1px solid var(--border);
  border-radius: 6px;
  padding: 4px 10px;
  font-size: 12px;
  white-space: nowrap;
  cursor: pointer;
  transition: all 0.15s ease;

  &:hover {
    background-color: var(--surface-elevated);
    border-color: var(--accent);
    color: var(--foreground);
  }
`;

const CheckBoxContainer = styled.div<{
  disabled: boolean;
  align: 'center' | 'left';
}>`
  display: flex;
  align-items: center;
  justify-content: ${props => props.align};
  gap: 8px;
  cursor: ${props => (props.disabled ? 'default' : 'pointer')};
  opacity: ${props => (props.disabled ? 0.5 : 1)};

  .checkbox-text {
    color: var(--foreground);
    font-size: var(--text-xs);
    line-height: 140%;
    text-align: left;
  }
`;

const CheckBox = styled.div<{ isChecked: boolean }>`
  outline: 0;
  background-color: ${props =>
    props.isChecked ? 'var(--accent)' : 'transparent'};
  width: 16px;
  height: 16px;
  border-radius: 2px;
  overflow: hidden;
  border: 1px solid
    ${props => (props.isChecked ? 'var(--accent)' : 'var(--text-muted)')};
  box-sizing: border-box;
  flex-shrink: 0;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const HelperText = styled.div<{ align: 'center' | 'left' }>`
  color: var(--text-muted);
  font-size: var(--text-xs);
  line-height: 140%;
  text-align: ${props => props.align};
`;

const LoadingText = styled.div`
  color: var(--text-muted);
  font-size: var(--text-sm);
  text-align: center;
  padding: 10px 0;
  margin-top: 8px;
`;

const NoSpeakersText = styled.div`
  color: var(--text-muted);
  font-size: var(--text-xs);
  text-align: center;
  font-style: italic;
  padding: 8px 0;
  margin-top: 8px;
`;

const SpeakerSelectorContainer = styled.div`
  margin-top: 4px;
`;

const SpeakerInfo = styled.div`
  color: var(--text-muted);
  font-size: var(--text-xs);
  text-align: center;
  font-style: italic;
  padding: 8px 0;
  margin-top: 4px;
`;
